import { render, staticRenderFns } from "./PanicIcon.vue?vue&type=template&id=28a257bd"
import script from "./PanicIcon.vue?vue&type=script&lang=js"
export * from "./PanicIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports